import * as React from 'react';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router-dom';
import { Divider, Stack, ListItemButton, ListItemIcon, ListItemText, List } from '@mui/material';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LineAxisIcon from '@mui/icons-material/LineAxis';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import AddReactionIcon from '@mui/icons-material/AddReaction';
import CategoryIcon from '@mui/icons-material/Category';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTranslation } from 'react-i18next';

export default function ScrollableTabsButtonPrevent() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isAdmin = localStorage.getItem('isAdmin') === 'true';
  const isModerator = localStorage.getItem('isModerator') === 'true';

  const buttons = [
    { labelKey: 'nav.dashboard',      path: '/dashboard',      icon: <LineAxisIcon fontSize="small" />,           permission: 'isUser' },
    { labelKey: 'nav.customers',      path: '/customers',      icon: <SupervisorAccountIcon fontSize="small" />,  permission: 'isUser' },
    { labelKey: 'nav.rmas',           path: '/rmas',           icon: <ConfirmationNumberIcon fontSize="small" />, permission: 'isUser' },
    { labelKey: 'nav.emailTraffic',   path: '/email-traffic',  icon: <MarkEmailReadIcon fontSize="small" />,      permission: 'isModerator' },
    { labelKey: 'nav.warehouse',      path: '/warehouse',      icon: <WarehouseIcon fontSize="small" />,          permission: 'isAdmin' },
    { labelKey: 'nav.notifications',  path: '/notifications',  icon: <NotificationsIcon fontSize="small" />,      permission: 'isUser' },
    { labelKey: 'nav.reports',        icon: <EqualizerIcon fontSize="small" />,                                   permission: 'hidden' },
    { labelKey: 'nav.dbZotac',        path: '/db-zotac',       icon: <AddReactionIcon fontSize="small" />,        permission: 'isAdmin' },
    { labelKey: 'nav.account',        path: '/account',        icon: <AssignmentIndIcon fontSize="small" />,      permission: 'isUser' },
    { labelKey: 'nav.newCustomer',    icon: <AddReactionIcon fontSize="small" />,                                 permission: 'hidden' },
    { labelKey: 'nav.palette',        icon: <CategoryIcon fontSize="small" />,                                    permission: 'hidden' },
    { labelKey: 'nav.admin',          path: '/admin',          icon: <AdminPanelSettingsIcon fontSize="small" />, permission: 'isAdmin' },
    { labelKey: 'nav.articles',       path: '/articles',       icon: <AddReactionIcon fontSize="small" />,        permission: 'isUser' },
    { labelKey: 'nav.logout',         path: '/auth/logout',    icon: <LogoutIcon fontSize="small" />,             permission: 'isUser' },
  ];

  const visibleButtons = buttons.filter((item) => {
    if (item.permission === 'hidden' || !item.path) return false;
    if (item.permission === 'isAdmin' && !isAdmin) return false;
    if (item.permission === 'isModerator' && !isAdmin && !isModerator) return false;
    return true;
  });

  return (
    <List component="nav" sx={{ mt: 2 }}>
      {visibleButtons.map((item) => {
        const { labelKey, path, icon } = item;
        const selected = pathname === path;
        return (
          <ListItemButton
            key={path}
            selected={selected}
            onClick={() => navigate(path)}
            sx={{ borderRadius: 1, mb: 0.5 }}
          >
            <ListItemIcon sx={{ minWidth: 36 }}>{icon}</ListItemIcon>
            <ListItemText primary={t(labelKey)} />
          </ListItemButton>
        );
      })}
    </List>
  );
}
